/**
 * The days of a Register's period as Tashkent reads them (ticket 16): the period
 * is named by calendar days there, `YYYY-MM-DD`, both inclusive.
 */

/** Tashkent is UTC+5 all year: the day it is there, `YYYY-MM-DD`, `back` days before. */
export function tashkentDay(now: Date, back = 0): string {
	const local = new Date(now.getTime() + 5 * 60 * 60 * 1000 - back * 24 * 60 * 60 * 1000)
	return local.toISOString().slice(0, 10)
}

/** The first day of the month a day `YYYY-MM-DD` is in. */
export function firstOfMonth(day: string): string {
	return `${day.slice(0, 8)}01`
}

/** `YYYY-MM-DD` as a person reads it: `DD.MM.YYYY`. */
export function readableDay(day: string): string {
	return day.split('-').reverse().join('.')
}
